// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3B4BF","title":"Header_title__ZgCo4","side":"Header_side__3-FKa"};